import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CadastroAdminGrupoService } from './cadastro-admin-grupo.service';
import { NotificationsService } from 'angular2-notifications';
import { CommonService } from '../../../../shared/services/commom.service';
import { Location } from '@angular/common';
import { EncriptyUtilService } from '../../../../shared/services/encripty-util.service';

@Component({
  selector: 'ngx-cadastro-admin-grupo',
  templateUrl: './cadastro-admin-grupo.component.html',
  styleUrls: ['./cadastro-admin-grupo.component.scss']
})
export class CadastroAdminGrupoComponent implements OnInit {

  public formCadastroGrupo = null;
  public listCardStatus = null;
  public grupoId = null;
  public descricao = null;
  public produtoId = null;
  public status = null;
  public showId = false;
  public listaProduto: any = [];
  public isCadastrar = false;
  public isEditar = false;
  formListGrupo: any;
  locastyle: any;
  public customLogin = null;

  constructor(

    private formBuilder: FormBuilder,
    private CadastroAdminGrupoService: CadastroAdminGrupoService,
    private commonService: CommonService,
    private route: ActivatedRoute,
    private notifications: NotificationsService,
    private location: Location,
    private encriptyService: EncriptyUtilService,
    private service: CadastroAdminGrupoService,
    private router: Router,

  ) {

    this.route.queryParamMap.subscribe(params => {

      this.grupoId = this.encriptyService.decriptyBySecretKey(params.get('id'));
      this.descricao = this.encriptyService.decriptyBySecretKey(params.get('descricao'));
      this.produtoId = this.encriptyService.decriptyBySecretKey(params.get('produtoId'));
      this.status = this.encriptyService.decriptyBySecretKey(params.get('status'));

      if (this.grupoId !== null) {

        this.isEditar = true;
        this.isCadastrar = false;
        this.editarCadastroForm(this.grupoId)

      } else {

        this.isCadastrar = true;
        this.isEditar = false;
      }

    });


    this.listCardStatus = [

      {
        status: 'ATIVO',
        descricao: 'ATIVO'
      },

      {
        status: 'INATIVO',
        descricao: 'INATIVO'
      },

    ];

    this.formCadastroGrupo = this.formBuilder.group({
      id: [null],
      descricao: [null, Validators.required],
      status: [null, Validators.required],
      produtoId: [null, Validators.required]
    });

    this.commonService.buscaProdutos()
      .subscribe(
        response => (
          this.listaProduto = response
        ));

  }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
  }

  salvarCadastro(data) {

    let cadastro = {

      descricao: data.descricao,
      produtoId: data.produtoId,
      status: data.status,

    }

    if (this.validaCampo(data)) {

      if (data.id === null) {

        this.service.cadastrarProduto(cadastro, (response => {
          this.formatSaveCadastro(response)
        }), (error) => {
          this.notifications.error(error.message);
        });
      } else {
        this.CadastroAdminGrupoService.editarCadastro(data.id, cadastro)
          .subscribe(
            response => (

              this.formatSaveEdit(response)

            ));

      }

    }

  }

  formatSaveCadastro(ret) {

    if (ret || ret == null) {

      this.notifications.success("Cadastro realizado com sucesso.")

      let id = this.encriptyService.encriptyBySecretKey('' + ret.id).toString();
      let descricao = this.encriptyService.encriptyBySecretKey('' + ret.descricao).toString();
      let produtoId = this.encriptyService.encriptyBySecretKey('' + ret.produtoId).toString();
      let status = this.encriptyService.encriptyBySecretKey('' + ret.status).toString();
      let params = { grupoId: id, descricao: descricao, produtoId: produtoId, produtoNome: null, status: status };
      this.router.navigate(['../tela-grupo-menus'], { relativeTo: this.route, queryParams: params });


      this.formCadastroGrupo = this.formBuilder.group({

        id: [null],
        descricao: [null],
        status: [null],
        produtoId: [null]

      });

      this.limparForm();

    }

  }

  formatSaveEdit(ret) {

    if (ret || ret == null) {

      this.formCadastroGrupo = this.formBuilder.group({

        id: [null],
        descricao: [null],
        status: [null],
        produtoId: [null]

      });

      this.notifications.success(
        "Ateração do Grupo realizado com sucesso."
      )

      this.limparForm();

    }

  }

  editarCadastroForm(data) {

    let editar = {

      descricao: this.descricao,
      produtoId: this.produtoId,
      status: this.status,

    }

    this.CadastroAdminGrupoService.editarCadastro(data, editar)

      .subscribe(
        response => (
          this.mountEdicaoCadastro(response)
        ));

  }

  mountEdicaoCadastro(data) {

    if (data.id != null) {

      this.formCadastroGrupo.controls['id'].setValue(data.id);
      this.formCadastroGrupo.controls['descricao'].setValue(data.descricao);
      this.formCadastroGrupo.controls['status'].setValue(data.status);
      this.formCadastroGrupo.controls['produtoId'].setValue(data.produtoId);

    }


  }


  limparForm() {

    this.formCadastroGrupo = this.formBuilder.group({

      id: [null],
      descricao: [null],
      status: [null],
      produtoId: [null]

    });

  }

  validaCampo(data) {

    if ((data.descricao === null) || (data.descricao === '')) {
      this.notifications.error("O campo nome do grupo é obrigatório.");
      return false
    }

    if ((data.produtoId === null) || (data.produtoId === 'null')) {
      this.notifications.error("O campo produto é obrigatório.");
      return false
    }

    if ((data.status === null) || (data.status === 'null')) {
      this.notifications.error("O campo status é obrigatório.");
      return false
    }

    return true

  }

  previousPage() {
    this.location.back();
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }
}
